import React from 'react';
import { Box } from '@mui/material';
import FieldRow from './FieldRow';
import SectionBlock from './SectionBlock';
import ImagePreview from './ImagePreview';
import { formatMinor } from './buildComparisonRows';

// A package's member being added or removed — says which package, and what the item is.
// (The inbox and the read-only view draw this as a before/after list instead, see buildMembershipRows.)
export default function PackageItemDetailPanel({ data, diffKeys = new Set(), side, lookups }) {
  if (!data) return null;

  const price = data.standalonePrice
    ? formatMinor(data.standalonePrice.baseCost, data.standalonePrice.currencyId, lookups)
    : null;

  return (
    <Box>
      {(data.packageName || data.packageId > 0) && (
        <>
          <SectionBlock title="Package" />
          <FieldRow label="Package" value={data.packageName ?? `Package ${data.packageId}`} side={side} />
        </>
      )}

      <SectionBlock title="Package Membership" />
      <FieldRow
        label="Item"
        value={data.name ?? (data.itemId != null ? `Item ${data.itemId}` : null)}
        isChanged={diffKeys.has('itemId')}
        side={side}
      />
      <FieldRow
        label="Quantity"
        value={data.quantity}
        isChanged={diffKeys.has('quantity')}
        side={side}
      />
      {data.itemTypeName && <FieldRow label="Type" value={data.itemTypeName} side={side} />}
      {price && <FieldRow label="Price" value={price} side={side} />}
      {data.thumbnailUrl && (
        <Box sx={{ px: 2, pb: 1 }}>
          <ImagePreview url={data.thumbnailUrl} width={96} height={64} />
        </Box>
      )}
    </Box>
  );
}
